class PolicyAmendment {
    constructor(
        amendmentNumber,
        date,
        id,
        prize,
        policyId,
        type,
        description,
        validFrom,
        contractMonthValidTo
    ) {
        this.amendmentNumber = amendmentNumber
        this.date = date
        this.id = id
        this.prize = prize
        this.policyId = policyId
        this.type = type
        this.description = description
        this.validFrom = validFrom
        this.contractMonthValidTo = contractMonthValidTo
    }

    static fromJson({
        amendmentNumber,
        date,
        id,
        prize,
        policyId,
        type,
        description,
        validFrom,
        contractMonthValidTo,
    }) {
        return new PolicyAmendment(
            amendmentNumber,
            date,
            id,
            prize,
            policyId,
            type,
            description,
            validFrom,
            contractMonthValidTo
        )
    }
}

export default PolicyAmendment
